import React from 'react';
import {Typography} from '../typography/Typography';
import {Button, CmsButtonProps} from '../buttons/Button';
import Grid from '@material-ui/core/Grid';
import {GridContainer} from '../grid';
import {VerticalSpacer} from '../spacer/VerticalSpacer';
import {AccentColorOptions} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps/animation';
import styled from 'styled-components';

export const LineTextBlockWrapper = styled.div<{centerAlignText?: boolean;}>`
    h2 {
        color: ${(p) =>
            p.theme.ifLight(p, p.theme.palette.common.black, p.theme.palette.common.white)};
        text-overflow: ellipsis;
        overflow: hidden;
    }
    hr {
        margin: 0;
        border-color: ${(p) =>
            p.theme.ifLight(p, p.theme.palette.neutral.steel, p.theme.palette.neutral.silver)};
        border-style: solid;
        border-width: 1px 0 0 0;
        opacity: 1;
    }
    a .tertiary {
        max-width: 100%;
        .underline {
            max-width: 100%;
            .button {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }

    ${(p) => p.centerAlignText &&  ` text-align: center;` } 
`;

export interface LineTextBlockProps {
    headline?: string;
    button?: CmsButtonProps;
    disableAnim?: boolean;
    hideHR?: boolean;
    className?: string;
    accentColor?: AccentColorOptions;
    centerAlignText?: boolean;
}

export const LineTextBlock = (props: LineTextBlockProps): JSX.Element | null => {
    const {headline, button = {}, disableAnim, hideHR, className, accentColor = 'sky', centerAlignText} = props;

    if (!headline && !button.href) return null;

    return (
        <LineTextBlockWrapper className={className} centerAlignText={centerAlignText}>
            <AnimateOnViewWrap translateY={25} disable={disableAnim}>
                <Grid
                    container
                    justifyContent="space-between"
                    alignItems="flex-end"
                    direction="row"
                    spacing={0}>
                    {headline && (
                        <Grid item xs={12} sm={true}>
                            <Typography variant="h2">{headline}</Typography>
                        </Grid>
                    )}
                    {button.href && (
                        <Grid item xs={12} sm={'auto'}>
                            <VerticalSpacer variant="custom" downSmSpacing={4} />
                            <Button
                                href={button.href}
                                type={button.type || 'tertiary'}
                                color={accentColor}>
                                {button.label || 'See all'}
                            </Button>
                        </Grid>
                    )}
                </Grid>
                <VerticalSpacer variant="custom" spacing={3} downSmSpacing={2} />
            </AnimateOnViewWrap>
            {!hideHR && <hr />}
        </LineTextBlockWrapper>
    );
};

export const LineTextBlockWithContainer = (props: LineTextBlockProps): JSX.Element | null => {
    return (
        <GridContainer>
            <LineTextBlock {...props} />
        </GridContainer>
    );
};
